import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { useCountUp } from 'utils/hooks/useCountUp';
import AutoScrollHorizontal from 'components/AutoScrollHorizontal';
import PartnerLogo1 from 'public/images/landing/partners/partner-logo-1.webp'
import PartnerLogo2 from 'public/images/landing/partners/partner-logo-2.webp'
import PartnerLogo3 from 'public/images/landing/partners/partner-logo-3.webp'
import PartnerLogo4 from 'public/images/landing/partners/partner-logo-4.webp'
import PartnerLogo5 from 'public/images/landing/partners/partner-logo-5.webp'
import PartnerLogo6 from 'public/images/landing/partners/partner-logo-6.webp'
import PartnerLogo7 from 'public/images/landing/partners/partner-logo-7.webp'
import PartnerLogo8 from 'public/images/landing/partners/partner-logo-8.webp'
import PartnerLogo9 from 'public/images/landing/partners/partner-logo-9.webp'
import PartnerLogo10 from 'public/images/landing/partners/partner-logo-10.webp'
import PartnerLogo11 from 'public/images/landing/partners/partner-logo-11.webp'
import PartnerLogo12 from 'public/images/landing/partners/partner-logo-12.webp'
import PartnerLogo13 from 'public/images/landing/partners/partner-logo-13.webp'
import PartnerLogo14 from 'public/images/landing/partners/partner-logo-14.webp'
import PartnerLogo15 from 'public/images/landing/partners/partner-logo-15.webp'
import PartnerLogo16 from 'public/images/landing/partners/partner-logo-16.webp'
import PartnerLogo17 from 'public/images/landing/partners/partner-logo-17.webp'
import PartnerLogo18 from 'public/images/landing/partners/partner-logo-18.webp'
import PartnerLogo19 from 'public/images/landing/partners/partner-logo-19.webp'
import PartnerLogo20 from 'public/images/landing/partners/partner-logo-20.webp'
import PartnerLogo21 from 'public/images/landing/partners/partner-logo-21.webp'
import PartnerLogo22 from 'public/images/landing/partners/partner-logo-22.webp'
import PartnerLogo23 from 'public/images/landing/partners/partner-logo-23.webp'
import PartnerLogo24 from 'public/images/landing/partners/partner-logo-24.webp'
import PartnerLogo25 from 'public/images/landing/partners/partner-logo-25.webp'
import PartnerLogo26 from 'public/images/landing/partners/partner-logo-26.webp'
import PartnerLogo27 from 'public/images/landing/partners/partner-logo-27.webp'
import PartnerLogo28 from 'public/images/landing/partners/partner-logo-28.webp'
import PartnerLogo29 from 'public/images/landing/partners/partner-logo-29.webp'
import PartnerLogo30 from 'public/images/landing/partners/partner-logo-30.webp'
import PartnerLogo31 from 'public/images/landing/partners/partner-logo-31.webp'
import PartnerLogo32 from 'public/images/landing/partners/partner-logo-32.webp'
import PartnerLogo33 from 'public/images/landing/partners/partner-logo-33.webp'
import PartnerLogo34 from 'public/images/landing/partners/partner-logo-34.webp'
import PartnerLogo35 from 'public/images/landing/partners/partner-logo-35.webp'
import PartnerLogo36 from 'public/images/landing/partners/partner-logo-36.webp'
import PartnerLogo37 from 'public/images/landing/partners/partner-logo-37.webp'
import PartnerLogo38 from 'public/images/landing/partners/partner-logo-38.webp'
import PartnerLogo39 from 'public/images/landing/partners/partner-logo-39.webp'
import PartnerLogo40 from 'public/images/landing/partners/partner-logo-30.webp'
import PartnerLogo41 from 'public/images/landing/partners/partner-logo-41.webp'

const logoPartners = [
  PartnerLogo1,
  PartnerLogo2,
  PartnerLogo3,
  PartnerLogo4,
  PartnerLogo5,
  PartnerLogo6,
  PartnerLogo7,
  PartnerLogo8,
  PartnerLogo9,
  PartnerLogo10,
  PartnerLogo11,
  PartnerLogo12,
  PartnerLogo13,
  PartnerLogo14,
  PartnerLogo15,
  PartnerLogo16,
  PartnerLogo17,
  PartnerLogo18,
  PartnerLogo19,
  PartnerLogo20,
  PartnerLogo21,
  PartnerLogo22,
  PartnerLogo23,
  PartnerLogo24,
  PartnerLogo25,
  PartnerLogo26,
  PartnerLogo27,
  PartnerLogo28,
  PartnerLogo29,
  PartnerLogo30,
  PartnerLogo31,
  PartnerLogo32,
  PartnerLogo33,
  PartnerLogo34,
  PartnerLogo35,
  PartnerLogo36,
  PartnerLogo37,
  PartnerLogo38,
  PartnerLogo39,
  PartnerLogo40,
  PartnerLogo41,
];

function PartnerSection() {
  const { t } = useTranslation();
  const [countMaritime, countMaritimeRef] = useCountUp({ start: 1, end: 45, duration: 500 });

  return (
    <div className="bg-grey-lightest py-32">
      <div className='max-w-1280 w-full mx-auto flex flex-col desktopSmall:flex-row px-20 desktopSmall:px-40 gap-20 items-center'>
        <div className='basis-full ipad:basis-1/3'>
          <h2 className='text-center ipad:text-left'>
            <p className="text-title3 text-primary">
              <span className='font-semibold'>{t('PartnerTrusted')} </span>
              <span className='font-semibold' ref={countMaritimeRef}>{`${countMaritime}+`}</span>
            </p>
            <p className='text-title3 font-light'>{t('PartnerCompanies')}</p>
          </h2>
        </div>

        <div className="basis-full ipad:basis-2/3 overflow-hidden relative w-full">
          {/* Left Gradient */}
          <div className="absolute left-0 top-0 h-full w-72 z-10 pointer-events-none bg-gradient-to-r from-grey-lightest to-transparent" />

          {/* Right Gradient */}
          <div className="absolute right-0 top-0 h-full w-72 z-10 pointer-events-none bg-gradient-to-l from-grey-lightest to-transparent" />

          <AutoScrollHorizontal speed={1}>
            {logoPartners?.map((item, index) => (
              <div
                className="shrink-0 px-20 py-12 flex items-center justify-center"
                key={index}
              >
                <Image
                  src={item.src}
                  alt='partners logo'
                  width={0}
                  height={0}
                  placeholder='blur'
                  blurDataURL={item.blurDataURL}
                  sizes="100vw"
                  className='h-auto w-auto max-h-40 ipad:max-h-72 max-w-full object-contain m-auto'
                />
              </div>
            ))}
          </AutoScrollHorizontal>
        </div>
      </div>
    </div>
  )
};

export default PartnerSection;
